'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../styles/colors.styles');

exports.default = _colors.baseColors;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/WMThemeProvider/colors.styles.js